import React from 'react';

const Radio = ({
    label,
    name,
    value,
    handleChange,
    error,
    required = false,
    options
}) => {
    // Gérer explicitement le changement de radio
    const handleRadioChange = (e) => {
        handleChange({
            target: {
                name: name,
                value: e.target.value
            }
        });
    };
    
    return (
        <div className="form-group">
            <label className="form-label text-muted text-start w-100">
                {label}
                {required && <span className="text-danger ms-1">*</span>}
            </label>
            <div className={`${error ? 'is-invalid' : ''} d-flex`}>
                {options.map((option, index) => (
                    <div className="form-check me-4" key={option.value}>
                        <input
                            type="radio"
                            className="form-check-input"
                            id={`${name}-${option.value}`}
                            name={name}
                            value={option.value}
                            checked={value === option.value}
                            onChange={handleRadioChange}
                        />
                        <label 
                            className="form-check-label"
                            htmlFor={`${name}-${option.value}`}
                        >
                            {option.label}
                        </label>
                    </div>
                ))}
            </div>
            {error && (
                <div className="invalid-feedback d-block">
                    {error}
                </div>
            )}
        </div>
    );
};

export default Radio;